import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { ContentCopy, Check } from '@mui/icons-material';

/**
 * Displays one-time MFA recovery codes in a monospace grid with a copy button.
 * Shown exactly once, right after setup.
 */
const RecoveryCodes = ({ codes = [] }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(codes.join('\n'));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard unavailable — codes are still visible on screen */
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 1,
          bgcolor: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: 2,
          p: 2,
        }}
      >
        {codes.map((c) => (
          <Box
            key={c}
            sx={{ fontFamily: 'monospace', fontSize: '0.95rem', textAlign: 'center', color: '#212529', py: 0.5 }}
          >
            {c}
          </Box>
        ))}
      </Box>
      <Button
        fullWidth
        startIcon={copied ? <Check /> : <ContentCopy />}
        onClick={handleCopy}
        sx={{ mt: 1.5, textTransform: 'none', color: '#2C3E50', fontWeight: 600 }}
      >
        {copied ? 'Copied' : 'Copy codes'}
      </Button>
    </Box>
  );
};

export default RecoveryCodes;
